document.addEventListener("DOMContentLoaded", function () {
  const messageWrapper = document.querySelector(".index-message-wrapper");
  const SESSION_HIDE_KEY = "indexMessageHidden";

  function isPageScrollable() {
    return document.documentElement.scrollHeight > window.innerHeight + 1;
  }

  function updateFixedClass() {
    if (!messageWrapper) return;
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const distanceFromBottom = documentHeight - (scrollPosition + windowHeight);

    if (!isPageScrollable()) {
      messageWrapper.classList.remove("is-fixed");
      return;
    }
    // If at bottom (within 100px), remove fixed
    if (distanceFromBottom <= 100) {
      messageWrapper.classList.remove("is-fixed");
    } else {
      messageWrapper.classList.add("is-fixed");
    }
  }

  function hasMessageContent() {
    const englishContent = messageWrapper.querySelector(
      ".index-message-english"
    );
    const japaneseContent = messageWrapper.querySelector(
      ".index-message-japanese"
    );
    const hasEnglish =
      englishContent && englishContent.textContent.trim().length > 0;
    const hasJapanese =
      japaneseContent && japaneseContent.textContent.trim().length > 0;
    return hasEnglish || hasJapanese;
  }

  let scrollTimeout;
  function handleScrollBehavior() {
    if (!hasMessageContent()) return;
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const distanceFromBottom = documentHeight - (scrollPosition + windowHeight);
    clearTimeout(scrollTimeout);
    if (!isPageScrollable()) {
      messageWrapper.style.opacity = "1";
      return;
    }
    if (distanceFromBottom <= 100) {
      messageWrapper.style.opacity = "1";
      return;
    }
    if (scrollPosition <= 50) {
      messageWrapper.style.opacity = "1";
    } else {
      messageWrapper.style.opacity = "0";
      scrollTimeout = setTimeout(() => {
        messageWrapper.style.opacity = "1";
      }, 1000);
    }
  }

  // Check sessionStorage: if hidden, hide immediately and skip logic
  if (sessionStorage.getItem(SESSION_HIDE_KEY) === "1") {
    if (messageWrapper) messageWrapper.style.display = "none";
    return;
  }

  // Initialize
  if (hasMessageContent()) {
    // Set initial state
    updateFixedClass();
    messageWrapper.style.opacity = "1";

    // Add scroll and resize listeners
    window.addEventListener(
      "scroll",
      function () {
        handleScrollBehavior();
        updateFixedClass();
      },
      { passive: true }
    );
    window.addEventListener(
      "resize",
      function () {
        handleScrollBehavior();
        updateFixedClass();
      },
      { passive: true }
    );

    // Run both handlers immediately on load to set correct state
    updateFixedClass();
    handleScrollBehavior();

    // Add click-to-hide functionality with fade out (session only)
    messageWrapper.addEventListener("click", function () {
      messageWrapper.style.opacity = "0";
      // After transition, hide for this session only
      const onTransitionEnd = function (e) {
        if (e.propertyName === "opacity") {
          messageWrapper.style.display = "none";
          sessionStorage.setItem(SESSION_HIDE_KEY, "1");
          messageWrapper.removeEventListener("transitionend", onTransitionEnd);
        }
      };
      messageWrapper.addEventListener("transitionend", onTransitionEnd);
    });
  } else {
    messageWrapper.style.display = "none";
  }
});
